// Porch / structural posts
//
// A post is a free-standing vertical member: porch and carport columns, deck
// posts, the open side of a pole barn. It is NOT a wall - it carries a roof but
// encloses nothing, so it never joins into a room, never accepts a door or a
// window, and never reads as a facade in an elevation.
//
// Sizes are the ACTUAL dressed dimensions in inches, not the nominal name, since
// that is what gets drawn: a 6x6 is 5.5" square.

export const POST_SIZES = {
  '4x4':      { label: '4×4',       width: 3.5,  depth: 3.5,  shape: 'square' },
  '4x6':      { label: '4×6',       width: 3.5,  depth: 5.5,  shape: 'square' },
  '6x6':      { label: '6×6',       width: 5.5,  depth: 5.5,  shape: 'square' },
  '8x8':      { label: '8×8',       width: 7.25, depth: 7.25, shape: 'square' },
  '10x10':    { label: '10×10',     width: 9.25, depth: 9.25, shape: 'square' },
  'boxed-8':  { label: '8" Boxed',  width: 8,    depth: 8,    shape: 'square' },
  'boxed-10': { label: '10" Boxed', width: 10,   depth: 10,   shape: 'square' },
  'round-6':  { label: '6" Round',  width: 6,    depth: 6,    shape: 'round' },
  'round-8':  { label: '8" Round',  width: 8,    depth: 8,    shape: 'round' },
  'round-10': { label: '10" Round', width: 10,   depth: 10,   shape: 'round' },
};

// How the post is shaped up its height. Only matters in elevation - in plan every
// style reads as its footprint.
export const POST_STYLES = {
  plain:   { label: 'Plain',     description: 'Square or round stock, no detail' },
  chamfer: { label: 'Chamfered', description: 'Eased corners, square cap and base' },
  turned:  { label: 'Turned',    description: 'Lathe-turned column' },
  tapered: { label: 'Tapered',   description: 'Craftsman taper, wide at the base' },
  boxed:   { label: 'Boxed',     description: 'Wrapped column with base and cap trim' },
};

export const POST_MATERIALS = {
  pt:        { label: 'Pressure-Treated', color: '#8f9d71' },
  cedar:     { label: 'Cedar',            color: '#b07a52' },
  fir:       { label: 'Douglas Fir',      color: '#c2a06a' },
  composite: { label: 'Composite / PVC',  color: '#e4e4de' },
  steel:     { label: 'Steel',            color: '#8a9099' },
  masonry:   { label: 'Masonry',          color: '#a89c8c' },
};

// Bases and caps are drawn in elevation only.
export const POST_BASE_TYPES = {
  none:     { label: 'None',            height: 0 },
  standoff: { label: 'Standoff Bracket', height: 2 },
  pier:     { label: 'Pier / Plinth',   height: 8 },
  wrap:     { label: 'Trim Wrap',       height: 6 },
};

// What the post stands on. A porch post bears on its own footing at grade; only a
// post on a raised deck starts at the finished floor.
export const POST_BEARINGS = {
  grade: { label: 'Grade / Footing' },
  floor: { label: 'Floor / Deck' },
};

export const DEFAULT_POST = {
  size: '6x6',
  style: 'plain',
  material: 'pt',
  base: 'standoff',
  bearing: 'grade',
  height: 96,      // inches, floor to beam
  rotation: 0,
};

/** Actual footprint of a post in inches, falling back to a 6x6. */
export const getPostFootprint = (post) => POST_SIZES[post?.size] || POST_SIZES['6x6'];

export const getPostColor = (post) =>
  (POST_MATERIALS[post?.material] || POST_MATERIALS.pt).color;
